<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((itemCamp, i) => {
                return {
                  headerLabel: this.stripHTML(get(itemCamp, ['title_en'])),
                  fields: [
                    new fields.WYSIWYG({
                      label: 'Title',
                      modelPath: [this, 'form', 'items', i, 'title'],
                      multilingual: true,
                      required: true,
                      hideToolbar: true
                    }),
                    new fields.Input({
                      label: 'Description',
                      modelPath: [this, 'form', 'items', i, 'description'],
                      multilingual: true,
                      required: true,
                      type: 'textarea'
                    }),
                    new fields.Image({
                      label: 'Image',
                      modelPath: [this, 'form', 'items', i, 'image'],
                      required: true,
                      onlyShowCoverCrop: true
                    }),
                    new fields.Link({
                      label: 'Camp link',
                      modelPath: [this, 'form', 'items', i, 'link'],
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  },
  methods: {
    stripHTML(value) {
      if (value) {
        return value.replace(/<\/?[^>]+>/gi, ' ').replaceAll('&nbsp;', '')
      }
      return value
    }
  }
}
</script>
